import { ROLES } from '../Constants/enums';

/**
 * Landing route for a freshly logged-in user based on the roles the login
 * response returned. PlatformAdmin opens Platform Administration; CIO opens CIO
 * Operations; CFO opens CFO Finance (handoff Flow A).
 */
export const homePathForRoles = (roles = []) => {
  // PlatformAdmin lands on the CIO Office dashboard (Sai's main view); account
  // management lives under Administration Users in the sidebar.
  if (roles.includes(ROLES.PLATFORM_ADMIN)) return '/cio';
  if (roles.includes(ROLES.CIO)) return '/cio';
  if (roles.includes(ROLES.CFO)) return '/cfo';
  // Support agents work the tickets assigned to them, so they land on the
  // Tech Support screen.
  if (roles.includes(ROLES.SUPPORT)) return '/cio/support';
  return '/no-workspace';
};
